module.exports = __webpack_public_path__ + "static/media/time.f27e0b12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/icon/time.svg
// module id = 763
// module chunks = 0